import { render, staticRenderFns } from "./EmptyRouterAlive.vue?vue&type=template&id=1b7f1fda&scoped=true"
import script from "./EmptyRouterAlive.vue?vue&type=script&lang=js"
export * from "./EmptyRouterAlive.vue?vue&type=script&lang=js"
import style0 from "./EmptyRouterAlive.vue?vue&type=style&index=0&id=1b7f1fda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f1fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7f1fda')) {
      api.createRecord('1b7f1fda', component.options)
    } else {
      api.reload('1b7f1fda', component.options)
    }
    module.hot.accept("./EmptyRouterAlive.vue?vue&type=template&id=1b7f1fda&scoped=true", function () {
      api.rerender('1b7f1fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/EmptyRouterAlive.vue"
export default component.exports